import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { BaseGridEditComponent, Color, GridEditorPageStateService, ViewChangeEvent } from '@identic/controls';
import { KeyValuePairs } from '@identic/core';
import { DiagnosisViewModel, DiagnosisFacade, DiagnosisService, DIAGNOSIS_DISPLAY_FIELD } from 'diagnosis/data-access';
import { convertColorToHex } from '../../../shared/utils';
import { listFields } from './editor-fields.data';

const SYNONYM_KEY = 'diagnosis';

@Component({
  selector: 'diagnosis-grid-edit',
  templateUrl: './editor.component.html'
})
export class DiagnosisEditorComponent extends BaseGridEditComponent<DiagnosisViewModel> implements OnInit {
  listName = 'Diagnosis';
  initialSortField = DIAGNOSIS_DISPLAY_FIELD;
  itemFields = listFields;

  detailGrouping?: string;
  detailLookupId?: string;
  synonymEditing: boolean = false;

  displayValueFns: KeyValuePairs<Function> = {};

  constructor(
    // Required for page state management
    public gridEditorPageStateService: GridEditorPageStateService,
    public route: ActivatedRoute,

    service: DiagnosisService,
    facade: DiagnosisFacade,
  ) {
    super(route, facade, { service });

    this.showSingleId = route.snapshot.params?.['id'];
  }


  override onCreate = (entity: DiagnosisViewModel): void => super.onCreate(convertColorToHex(entity));

  override onUpdate = (entity: DiagnosisViewModel): void => super.onUpdate(convertColorToHex(entity));

    override onViewChange(event: ViewChangeEvent): void {
    this.synonymEditing = false;

    if (event.view === 'detail') {
      const item: any = event.detailItem?.getRawValue();
      this.detailGrouping = SYNONYM_KEY;
      this.detailLookupId = item?.id;
    } else {
      this.detailGrouping = this.detailLookupId = undefined;
    }
    super.onViewChange(event);
  }
}
// console.log(`%cDiagnosisGridEditComponent::ngOnInit`, 'background:yellow');
